import React from 'react';
import { AiSmartFolder } from '../types';

interface AiSmartInboxNavProps {
  nested?: boolean;
  folders: AiSmartFolder[];
  selectedFolder: string;
  loading: boolean;
  error: string | null;
  onSelectFolder: (folderId: string) => void;
}

const AiSmartInboxNav: React.FC<AiSmartInboxNavProps> = ({
  nested = false,
  folders,
  selectedFolder,
  loading,
  error,
  onSelectFolder
}) => {
  const navClass = nested ? 'email-mailbox-nav email-mailbox-nav--nested' : 'email-mailbox-nav';

  if (loading && folders.length === 0) {
    return <div className={`email-mailbox-nav-state${nested ? ' email-mailbox-nav-state--nested' : ''}`}>Loading folders…</div>;
  }

  if (error && folders.length === 0) {
    return <div className={`email-mailbox-nav-state email-mailbox-nav-error${nested ? ' email-mailbox-nav-state--nested' : ''}`}>{error}</div>;
  }

  return (
    <nav className={navClass} aria-label="Smart inboxes">
      <ul className="email-mailbox-list">
        {folders.map(folder => (
          <li key={folder.id}>
            <button
              type="button"
              className={`email-mailbox-item${selectedFolder === folder.id ? ' active' : ''}`}
              onClick={() => onSelectFolder(folder.id)}
              title={folder.name}
            >
              {folder.name}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default AiSmartInboxNav;
